<script>
import cTable from "@/base/common/index.vue";
import {buildApi} from "@/libs/api.request";
import axios from "axios";
import {exportSummary, getCustomerWithSKU} from "@/api/system/customer";
import Customer from "_my/customer";
import Task from "_my/customer/task.vue"
import Printer from "_my/customer/printer.vue"

export default {
  name: "index",
  components: {cTable, Customer, Task, Printer},
  data() {
    return {
      customerCollection: [],
      config: {},
      footer: {},
      modals: {
        showUnpack: {
          contentSlot: "UNPACK",
          config: {
            modalBind: {
              width: 900,
              draggable: true,
              sticky: true,
              styles: {
                top: "30px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        showTask: {
          contentSlot: "TASK",
          config: {
            modalBind: {
              width: 860,
              draggable: true,
              sticky: true,
              styles: {
                top: "30px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        showPrinter: {
          contentSlot: "PRINTER",
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              sticky: true,
              styles: {
                top: "30px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$tz("请选择,关键字,类型");
            },
            component: "Select",
            options: [
              {label: '小包号码', value: 'small'},
              {label: '拆包号码', value: 'unpack'},
              {label: '任务编码', value: 'task'}
            ],
          },
          {
            key: "keywords",
            placeholder() {
              return this.$tz("请选择,关键字,类型");
            },
            component: "Input",
            placehoder: '请输入关键字'
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$tz("选择打印机"),
              type: "check",
              fnName: "check",
              bind: {
                type: "warning",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("showUnpack").open({}, function () {
                this.setTitle('选择CES拆包订单');
              });
            },
            check() {
              this.getModal("showPrinter").open({}, function () {
                this.setTitle('选择需要使用的打印机');
              });
            }
          },
        },
      },
      methods: {
        ...buildApi({
          get: ['/api/mock/package/index&list',],
          post: ['/api/mock/package/save']
        })
      },
      fields: [
        {
          name: () => this.$tz("批次号码"),
          key: "batch_number",
          width: 140,
        },
        {
          name: () => this.$tz("当前状态"),
          key: "status",
          width: 120,
          render(h, {row, index}) {
            if (row.status === 'WAITING') {
              return h('VxeButton', {props: {status: 'warning', size: 'mini'}}, '等待仓库操作')
            } else if (row.status === 'PICKING') {
              return h('VxeButton', {props: {status: 'info', size: 'mini'}}, '仓库拆包中')
            } else {
              return h('VxeButton', {props: {status: 'success', size: 'mini'}}, '已经结束操作')
            }
          }
        },
        {
          name: () => this.$tz("创建人"),
          key: "operator",
          width: 120,
        },
        {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          width: 230,
        },
        {
          name: () => this.$tz("所在仓库"),
          key: "operator_warehouse",
          width: 120,
        },
        {
          name: () => this.$tz("批次客户"),
          key: "allow_client",
          width: 400,
          render(h, {row, index}) {
            let buff = []
            for (const rowElement of row.allow_client) {
              buff.push(h('Tag', {props: {color: 'warning'}}, rowElement))
            }
            return h('div', {}, buff)
          }
        },
        {
          name: () => this.$tz("订单数量"),
          key: "shipment_count",
          width: 120,
        },
        {
          name: () => this.$tz("SKU数量"),
          key: "sku_count",
          width: 120,
        },
        {
          name: () => this.$tz("已签收数量"),
          key: "signed",
          width: 120,
        },
        {
          name: () => this.$t("operation"),
          width: 200,
          type: "btns",
          fixed: "right",
          list: [
            {
              name: this.$tz("导出数据"),
              type: "export",
              fnName: "exportSummary",
              bind: {
                type: "warning",
              },
            },
            {
              name: this.$tz("开始拆包"),
              type: "update",
              fnName: "startWork",
              bind: {
                type: "primary",
              },
            },

          ],
          methods: {
            startWork({row}) {
              this.getModal('showTask').open({params: row}, function () {
                this.setTitle(`开始批次（${row.batch_number}）拆包工作`);
              })
            },
            closePackage({row}) {

            },
            exportSummary({row}) {
              this.$Spin.show()
              exportSummary(row['batch_number']).then(r => {
                this.$Spin.hide()
                if (r.data.status) {
                  this.$Message.success('生成成功, 请等待下载')
                  window.open(r.data.payload)
                } else {
                  this.$Message.error(r.data.msg || '发生了其他的错误')
                }

              }).catch(e => {
                this.$Spin.hide()
                this.$Message.error(e.message)
              })
            }
          },
        },
      ],
    }
  }
}
</script>

<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #UNPACK="{ visible }">
      <Customer v-if="visible" />
    </template>

    <template #TASK="{ visible , params }">
      <Task v-if="visible" :batchNumber="params" />
    </template>

    <template #PRINTER="{ visible , params }">
      <Printer v-if="visible" :batchNumber="params" />
    </template>
  </cTable>
</template>

<style scoped>

</style>
